/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespTopModule_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSellerButton_viewer">;
    readonly " $refType": "PdpRespTopModule_viewer";
};
export type PdpRespTopModule_viewer$data = PdpRespTopModule_viewer;
export type PdpRespTopModule_viewer$key = {
    readonly " $data"?: PdpRespTopModule_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespTopModule_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTopModule_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'eede61d391044d193cde11d82052691b';
export default node;
